import React from "react";
import { useSearchParams } from "react-router-dom";

// Renders a top tab bar; each tab owns its own page padding.
export const TabPages = ({ testId, tabPrefix, tabs, defaultTab }) => {
  const [params, setParams] = useSearchParams();
  const active = tabs.find((t) => t.id === params.get("tab")) || tabs.find((t) => t.id === defaultTab) || tabs[0];

  return (
    <div data-testid={testId}>
      <div className="px-6 lg:px-10 pt-8">
        <div className="flex items-center gap-1.5 border-b border-border flex-wrap">
          {tabs.map((t) => (
            <button
              key={t.id}
              data-testid={`${tabPrefix}-tab-${t.id}`}
              onClick={() => setParams({ tab: t.id })}
              className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors duration-150 ${
                active.id === t.id
                  ? "border-[#00579e] text-[#00579e]"
                  : "border-transparent text-muted-foreground hover:text-foreground"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      </div>
      {active.render()}
    </div>
  );
};

export default TabPages;
